export default __webpack_public_path__ + "static/media/roboEmi.d3f9138e.png";